import { useMemo } from 'react'
import { startOfDay } from 'date-fns'
import { slugs } from '@/constants/slugs'
import { useTicketsContext } from '../../TicketsContext'

interface LimitedEventConfig {
  slug: string
  eventDate: Date
}

const LIMITED_EVENT_CONFIGS: LimitedEventConfig[] = [
  {
    slug: slugs.senior,
    eventDate: startOfDay(new Date(2025, 8, 8)),
  },
  {
    slug: slugs.truthAndTreason,
    eventDate: startOfDay(new Date(2025, 9, 6)),
  },
  {
    slug: slugs.david,
    eventDate: startOfDay(new Date(2025, 11, 8)),
  },
]

export const useShouldShowLimitedEvent = (theatricalSlug?: string) => {
  const { experiments } = useTicketsContext()

  return useMemo(() => {
    if (!theatricalSlug) return { shouldShow: false, eventDate: null, hasLimitedEvent: false }

    const config = LIMITED_EVENT_CONFIGS.find(({ slug }) => slug === theatricalSlug)
    if (!config) return { shouldShow: false, eventDate: null, hasLimitedEvent: false }

    const shouldShow = config.eventDate >= startOfDay(new Date()) && experiments?.['premiere_card'] !== 'hidden'

    return {
      shouldShow,
      eventDate: config.eventDate,
      hasLimitedEvent: true,
    }
  }, [experiments, theatricalSlug])
}
